import axios from "axios";

// In browser, prefer same-origin (`/api/...`) so the frontend always calls the
// backend exposed on the same domain it is served from. This makes the build
// portable across multiple deploy domains (preview, production, custom domains)
// without needing a rebuild. We fall back to REACT_APP_BACKEND_URL only when
// running outside the browser (SSR, tests).
const BACKEND_URL = (typeof window !== "undefined" && window.location?.origin)
    ? ""
    : (process.env.REACT_APP_BACKEND_URL || "");
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Attach appropriate token based on URL
api.interceptors.request.use((config) => {
    const url = config.url || "";
    if (url.includes("/superadmin")) {
        const t = localStorage.getItem("superadmin_token");
        if (t) config.headers.Authorization = `Bearer ${t}`;
    } else if (url.startsWith("/admin") || url.includes("/admin/")) {
        const t = localStorage.getItem("admin_token");
        if (t) config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
});

export default api;
